import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../api/axiosClient';
import { API_BASE_URL, getBearerJsonHeaders } from '../../api/constant';

const CART_REQ_MS = 25000;

const cartReq = (config) => ({
  ...config,
  headers: { ...getBearerJsonHeaders(), ...config.headers },
  timeout: CART_REQ_MS,
});

export const fetchCart = createAsyncThunk('cart/fetchCart', async () => {
  const response = await axios.get(`${API_BASE_URL}/api/cart`, cartReq({}));
  return response.data;
});

export const addToCart = createAsyncThunk('cart/addToCart', async (item, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/cart`, item, cartReq({}));
    return response.data;
  } catch (e) {
    const data = e.response?.data;
    const msg =
      (data && typeof data === 'object' && (data.message || data.error)) ||
      (typeof data === 'string' ? data : null) ||
      e.message ||
      'Error al agregar al carrito';
    return rejectWithValue(typeof msg === 'string' ? msg : JSON.stringify(msg));
  }
});

export const removeFromCart = createAsyncThunk('cart/removeFromCart', async (id) => {
  await axios.delete(`${API_BASE_URL}/api/cart/${id}`, cartReq({}));
  return id;
});

export const clearCart = createAsyncThunk('cart/clearCart', async () => {
  try {
    await axios.delete(`${API_BASE_URL}/api/cart`, cartReq({}));
    return [];
  } catch (error) {
    console.error('Error clearing cart:', error);
    return [];
  }
});

/** Body must match backend UserCartDto (id optional for new lines). */
export const updateCartItemQuantity = createAsyncThunk(
  'cart/updateCartItemQuantity',
  async (payload) => {
    const response = await axios.post(`${API_BASE_URL}/api/cart`, payload, cartReq({}));
    return response.data;
  }
);

const upsertById = (state, item) => {
  if (!item?.id) return;
  const idx = state.cart.findIndex((c) => c.id === item.id);
  if (idx >= 0) {
    state.cart[idx] = { ...state.cart[idx], ...item };
  } else {
    state.cart.push(item);
  }
};

const initialState = {
  cart: [],
  status: 'idle',
  error: null,
};

const cartSlice = createSlice({
  name: 'cartState',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCart.fulfilled, (state, action) => {
        state.cart = action.payload || [];
        state.status = 'succeeded';
      })
      .addCase(addToCart.fulfilled, (state, action) => {
        upsertById(state, action.payload);
        state.status = 'succeeded';
      })
      .addCase(updateCartItemQuantity.fulfilled, (state, action) => {
        upsertById(state, action.payload);
        state.status = 'succeeded';
      })
      .addCase(removeFromCart.fulfilled, (state, action) => {
        state.cart = state.cart.filter((c) => c.id !== action.payload);
        state.status = 'succeeded';
      })
      .addCase(clearCart.pending, (state) => {
        state.cart = [];
      })
      .addCase(clearCart.fulfilled, (state) => {
        state.cart = [];
        state.status = 'succeeded';
      })
      .addCase(clearCart.rejected, (state) => {
        state.cart = [];
      });
  },
});

export default cartSlice.reducer;
export const selectCartItems = (state) => state.cartState.cart;
